import Color from './color';

export default class ColorStop {
  constructor(
    public color: Color,
    public ratio: number
  ) {}
}
